import { render, staticRenderFns } from "./LibraryResourcePodcast.vue?vue&type=template&id=6e7e70a6&"
import script from "./LibraryResourcePodcast.vue?vue&type=script&lang=js&"
export * from "./LibraryResourcePodcast.vue?vue&type=script&lang=js&"
import style0 from "./LibraryResourcePodcast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports